import localStorage from './localStorage';

const api = {
  localApi: process.env.REACT_APP_API_URL === 'restcore' ?
    "https://bimeh.com/api" :
    process.env.REACT_APP_API_URL === 'test' ?
      "http://localhost:3000/api" :
      "http://localhost:3000/api",
  restcore: "https://coreapi.bimeh.com",
  test: "https://frontcore.bimeh.com",
};

const apiUrls = () => {
  let url;

  const debug = localStorage.loadState('api');

  if (debug) {

    url = localStorage.loadState('api');

  } else if (process.env.REACT_APP_API_URL === 'restcore') {
    url = api.restcore;

  } else if (process.env.REACT_APP_API_URL === 'test') {
    url = api.test;
  }
  else {
    url = api.test;
  }
  if (!url) {
    url = api.restcore;
  }
  return url;
  // return api.restcore;
};


export default {
  apiUrls,
  api
};


// export default {
//     api: {
// restcore: process.env.REACT_APP_API_URL === 'restcore' ?
//     "https://core.bimeh.com" :
//     process.env.REACT_APP_API_URL === 'test' ?
//         "https://testapi.bimeh.com" :
//         "https://testapi.bimeh.com", //You can only edit this address. There are two more addresses to build



// localApi: process.env.REACT_APP_API_URL === 'restcore' ?
//   "https://bimeh.com/api" :
//   process.env.REACT_APP_API_URL === 'test' ?
//     "http://localhost:3000/api" :
//     "http://localhost:3000/api"
// }
// }
